/* tslint:disable */

declare var Object: any;
export interface CostRateInterface {
  "fromDate": Date;
  "rate": number;
  "id"?: any;
}

export class CostRate implements CostRateInterface {
  "fromDate": Date;
  "rate": number;
  "id": any;
  constructor(data?: CostRateInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CostRate`.
   */
  public static getModelName() {
    return "CostRate";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CostRate for dynamic purposes.
  **/
  public static factory(data: CostRateInterface): CostRate{
    return new CostRate(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CostRate',
      plural: 'CostRates',
      path: 'CostRates',
      idName: 'id',
      properties: {
        "fromDate": {
          name: 'fromDate',
          type: 'Date'
        },
        "rate": {
          name: 'rate',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
